import React from 'react';
import '../assets/stylesheets/loader.css';

const Loader = () => {

    return (
        <div className="loader-container">
            <svg width="400" height="400" viewBox="0 0 500 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="openbook 1">
                <g id="layer1">
                <path id="path2469" d="M40.5355 46.8076H210.891C210.891 47.2248 210.891 86.5597 251.954 85.3886C294.284 86.7736 294.284 46.8076 294.284 46.8076H463.372" stroke="black" strokeWidth="7.3" strokeLinecap="round" strokeLinejoin="round"/>
                <path id="p10" d="M411.81 22.4396L251.966 22.4397" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p9" d="M411.844 22L252 22.0001" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p8" d="M411.844 22L252 22.0001" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p7" d="M411.844 22L252 22.0001" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p6" d="M411.844 22L252 22.0001" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p5" d="M410 22H250" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p4" d="M411.81 22.4396L251.966 22.4397" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p3" d="M411.81 22.4396L251.966 22.4397" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p2" d="M411.81 22.4396L251.966 22.4397" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                <path id="p1" d="M411.81 22.4396L251.966 22.4397" stroke="black" strokeWidth="6" strokeLinecap="round"/>
                </g>
                </g>
            </svg>

            <div className="details">
                <div className="book-title">
                    Book Title
                </div>

                <div className="author">
                    Author's name
                </div>
            </div>

            <div>
                <svg className="rotate-device" width="210" height="297" viewBox="0 0 210 297" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M101.028 142.919H114.391C117.057 142.919 119.202 145.065 119.202 147.73V161.895C119.202 164.56 117.057 166.706 114.391 166.706H96.2167" stroke="black" strokeWidth="1.5875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M96.2168 166.706H82.0517C79.3865 166.706 77.2409 164.56 77.2409 161.895V147.73" stroke="black" strokeWidth="1.5875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M116.964 152.808V156.884" stroke="black" strokeWidth="0.794279" strokeLinecap="round"/>
                    <path d="M96.217 124.745H82.0517C79.3948 124.745 77.2409 126.899 77.2409 129.556V161.895C77.2409 164.552 79.3948 166.706 82.0517 166.706H96.217C98.874 166.706 101.028 164.552 101.028 161.895V129.556C101.028 126.899 98.874 124.745 96.217 124.745Z" stroke="black" strokeWidth="1.5875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M87.5665 164.539C86.9374 164.539 86.4274 164.029 86.4274 163.4C86.4274 162.77 86.9374 162.26 87.5665 162.26H90.7023C91.3314 162.26 91.8414 162.77 91.8414 163.4C91.8414 164.029 91.3314 164.539 90.7023 164.539H87.5665Z" stroke="black" strokeWidth="0.79375" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M87.1299 126.983H91.2057" stroke="black" strokeWidth="0.794279" strokeLinecap="round"/>
                    <path d="M92.3909 122.058C93.6212 120.77 95.1112 119.759 96.7622 119.091C98.4132 118.423 100.187 118.113 101.967 118.183C105.296 118.314 108.437 119.762 110.698 122.208C112.96 124.655 114.157 127.899 114.026 131.228V131.228C114.018 131.437 114.004 131.645 113.986 131.853" stroke="black" strokeWidth="1.5875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M111.177 131.48L116.542 132.708L113.026 135.735L111.177 131.48Z" fill="black" stroke="black" strokeWidth="1.5875" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div> 
        </div>
    )
}

export default Loader;